import React from "react"
import styled from "styled-components"
import { colors } from "../components/breakpoints"

const FooterSection = ({ className, header, headerLink, items = [] }) => {
  const decodedHeader = <div dangerouslySetInnerHTML={{ __html: header }} />

  return (
    <nav className={className}>
      {header && (
      <h3 className="footer-menu__title">
      {headerLink ? <a href={headerLink}>{decodedHeader}</a> : decodedHeader}
      </h3>
      )}
      <ul>
        {items.map(item => (
          <li className="nav-item" key={item.url ?? item.label}>
            {item?.url ? (
              <a className="nav-link active" href={item.url} alt={item.label}>
                {item.label}
              </a>
            ) : (
              item.label
            )}
          </li>
        ))}
      </ul>
    </nav>
  )
}
const StyledFooterSection = styled(FooterSection)`
  a {
    color: ${colors.secondary};
    text-decoration: none;
    &:visited {
      color: ${colors.secondary};
    }
    &:hover {
      color: ${colors.primary};
    }
  }
`
export default StyledFooterSection
